import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createModules, createSubscription, fetchAllSubscription, fetchModules, fetchSubscription, removeModules, removeSubscription, updateModules, updateSubscription, updateSubscriptionStatus } from "../../service/api";


export const getSubscription = createAsyncThunk(
    "subscription/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchSubscription(params)
            console.log("fetch subscription", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)

        }
    }
)

export const getAllSubscription = createAsyncThunk(
    "subscription/alls",
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchAllSubscription()
            console.log("fetch all subscription", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)

        }
    }
)


export const addSubscription = createAsyncThunk(
    "subscription/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createSubscription(formValue)
            if (response.status === 201) {
                console.log("add sub", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editSubscription = createAsyncThunk(
    "subscription/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateSubscription(newData)
            if (response.status === 201) {
                console.log("edit subscription", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)



export const editSubscriptionStatus = createAsyncThunk(
    "subscription/editStatus",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateSubscriptionStatus(newData)
            if (response.status === 201) {
                console.log("edit status", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)

export const deleteSubscription = createAsyncThunk(
    "subscription/delete",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await removeSubscription(newData)
            if (response.status === 201) {
                console.log("edit modules", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)



const subscriptionSlice = createSlice({
    name: "subscriptions",
    initialState: {
        subscriptionList: [],
        allSubscriptionList: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: ""
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSubscription.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getSubscription.fulfilled, (state, action) => {
                state.isLoading = false;
                state.subscriptionList = action.payload.data;
                state.totalPage = action.payload.totalPage
            })
            .addCase(getSubscription.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //get all 

            .addCase(getAllSubscription.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getAllSubscription.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allSubscriptionList = action.payload.data;
                state.totalPage = action.payload.totalPage
            })
            .addCase(getAllSubscription.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })


            // POST

            .addCase(addSubscription.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addSubscription.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addSubscription.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editSubscription.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editSubscription.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editSubscription.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT STATUS
            .addCase(editSubscriptionStatus.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editSubscriptionStatus.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editSubscriptionStatus.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // delete
            .addCase(deleteSubscription.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteSubscription.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteSubscription.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})
export const { setSearchParams, setPagination } = subscriptionSlice.actions;


export default subscriptionSlice.reducer;